import { FC } from 'react'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'
import { EmployeeTabs } from './types'
import { EmployeesView } from './EmployeesView'
import { useEmployeeStore } from './EmployeeStore'
import { ResignedEmployeesView } from './ResignedEmployees/ResignedEmployeesView'

const { TabPane } = Tabs

export const EmployeeContent: FC = () => {
  const [activeTab] = useEmployeeStore((state) => [state.activeTab, state.setActiveTab], shallow)

  return (
    <>
      <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
        <TabPane key={EmployeeTabs.Active}>
          <EmployeesView />
        </TabPane>
        <TabPane key={EmployeeTabs.Resigned}>
          <ResignedEmployeesView />
        </TabPane>
      </Tabs>
    </>
  )
}
